import { PlayerClass } from './player';
export const PLAYERS : PlayerClass[] =[
  {name:'Kobe Bryant',keyCode:'D','color':'#BD10E0',score:0,duration:'0s',dribbles_left:0},
  {name:'LeBron James',keyCode:'K','color':'#9013FE',score:0,duration:'0s',dribbles_left:0},
  {name:'Magic Johnson',keyCode:'Z','color':'#D0021B',score:0,duration:'0s',dribbles_left:0}
];
export const KEYCODES = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';



// WEBPACK FOOTER //
// C:/Users/BHAJ/Desktop/dribbler/src/app/player-stock.ts